
export enum DockShipmentListTypeCd {
	DIVERTED = 'Diverted',
	EXCLUDED = 'Excluded'}

